import { useSearchParams } from "next/navigation";
import { parse } from "qs";

import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import useSortQueryParam from "@/hooks/useSortQueryParam";
import pageFromQuery from "@/utils/pageFromQuery";

import {
  appliedFilterSections,
  extractFilterValues,
} from "@/components/UnifiedShop/utils/filterUtils";

export const useShopItemAd = () => {
  const countryCode = useDomainCountryCode();
  const { appliedSort } = useSortQueryParam();
  const searchParams = useSearchParams();
  const parsedQs = parse(searchParams?.toString() || "");
  const { selectedCategories, selectedFulfillments } =
    extractFilterValues(parsedQs);
  const currentPage = pageFromQuery(
    parsedQs.page as string | string[] | undefined,
  );

  const showShopItemAd = () => {
    return (
      !appliedFilterSections(parsedQs).some((item) => item !== "category") &&
      (selectedCategories?.length || 0) <= 1 &&
      (selectedFulfillments?.length || 0) === 0 &&
      currentPage === 1 &&
      appliedSort === undefined &&
      countryCode === "US"
    );
  };

  const targeting = () => {
    if (showShopItemAd()) {
      if (selectedCategories?.length === 1) {
        return { category: selectedCategories[0] };
      } else {
        return { category: "home" };
      }
    } else {
      return {};
    }
  };

  return {
    showShopItemAd,
    targeting,
  };
};
